import type { BillingService } from './billing.service.js'

let billingServiceInstance: BillingService | null = null

export function setBillingService(service: BillingService) {
  billingServiceInstance = service
}

export function getBillingService(): BillingService {
  if (!billingServiceInstance) {
    throw new Error('Billing service has not been initialized yet')
  }
  return billingServiceInstance
}

export function tryGetBillingService(): BillingService | null {
  try {
    return getBillingService()
  } catch {
    return null
  }
}
